import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from '../features/auth/AuthProvider';
import { systemDetailsPath } from '../features/system/systemState';

/** Landing por permissão (ADR-038): plataforma → painel (ADR-028); quem assiste
 *  ao vivo completo → /live; operador de monitoramento → /monitoring. */
export function Home() {
  const { session, can } = useAuth();
  if (session?.tenant.platform) return <Navigate to="/overview" replace />;
  if (can('live.view')) return <Navigate to="/live" replace />;
  if (can('monitoring.view')) return <Navigate to="/monitoring" replace />;
  return <Navigate to="/live" replace />; // fallback: RequirePermission mostra "Acesso negado"
}

/**
 * Operation screens do not exist on the platform, which has no cameras
 * (ADR-028). A bookmark or the login "next" left by another user (e.g. /live)
 * leads to the overview instead of an empty screen.
 */
export function NotOnPlatform({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  if (session?.tenant.platform) return <Navigate to="/overview" replace />;
  return children;
}

/**
 * The former /system page (until 0.66): its details are now a section of the
 * platform's "Painel", for super administrators only. Anyone else lands where
 * the app's root sends them.
 */
export function SystemMoved() {
  const { can } = useAuth();
  if (can('system.read')) return <Navigate to={systemDetailsPath} replace />;
  return <Home />;
}
